import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect, useRef } from 'preact/hooks';
import UnivaClient from '../../api/UnivaClient';
const CardBrandMapping = new Map([
    ["visa", 'VISA'],
    ["mastercard", 'MASTER'],
    ["american_express", 'AMEX'],
    ["diners_club", 'DINERS'],
    ["discover", 'DISCOVER'],
    ["jcb", 'JCB'],
    ["maestro", 'UNIONPAY'],
    ["unionpay", 'UNIONPAY'],
    ["unknown", 'UNIONPAY'],
]);
export const checkoutUnivapayToken = async (storeCredential) => {
    const data = await UnivapayCheckout.submit(document.querySelector('.univapay-checkout-form > iframe'));
    const { data: transactionToken } = await UnivaClient.retrieveToken(storeCredential.storeId, data.transactionToken);
    const cardData = transactionToken.data.card;
    const payTimes = parseInt(data.installmentCount ?? '1');
    return {
        cardBrandType: CardBrandMapping.get(cardData.brand ?? '') ?? 'UNIONPAY',
        cardno: `************${cardData.last_four}`,
        holdername: cardData.cardholder,
        expiremonth: `0${cardData.exp_month}`.slice(0, 2),
        expireyear: `${cardData.exp_year}`,
        cvc: null,
        sequence: null,
        payType: 'INPUT',
        paymentMethod: isNaN(payTimes) === true ? 'REVOLVING' : payTimes > 1 ? 'SPLIT' : 'BUNDLE',
        payTimes: isNaN(payTimes) ? 1 : payTimes,
        tokens: [data.transactionToken],
    };
};
const UnivapayCardInputForm = ({ storeIdentifier, onlyUseBundle, }) => {
    const wrapperRef = useRef(null);
    useEffect(() => {
        window.addEventListener('univapay:opened', () => {
            const iframes = wrapperRef.current?.querySelectorAll('iframe');
            if (iframes && iframes.length > 1) {
                iframes.item(1).remove();
            }
        });
    }, []);
    return (_jsx("div", Object.assign({ className: `univapay-checkout-form ${typeof storeIdentifier === 'undefined' ? 'is-hidden' : ''}`, ref: wrapperRef }, { children: storeIdentifier && (_jsx("span", { "data-app-id": storeIdentifier, "data-allow-card-installments": onlyUseBundle === true, "data-checkout": 'token', "data-token-type": 'recurring', "data-currency": 'jpy', "data-inline": 'true', "data-email": 'fp-ac@firstdeg.com', "data-size": 'small', "data-cvv-authorize": 'true' }, void 0)) }), void 0));
};
export default UnivapayCardInputForm;
